import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Phone } from '../model/Phone.model';
import { Observable } from 'rxjs';
import { URL_API } from './url.api';

@Injectable({
  providedIn: 'root'
})
export class PhoneService {

  constructor(
    private http: HttpClient
  ) { }

  save(phone: Phone): Observable<any> {
    return this.http.post<any>(`${URL_API}/phones`, phone);
  }

  delete(phone: Phone): Observable<any> {
    return this.http.delete<any>(`${URL_API}/phones/${phone.id}`);
  }

}
